import { GET, POST, PUT, DELETE } from './api';

export const CreateProfile = async (params: unknown, token: string) => {
  return await POST(`/profiles`, params, token);
};

export const ReadProfiles = async (token: string) => {
  return await GET(`/profiles?populate[0]=picture`, token);
};

export const ReadProfilePictures = async (token: string) => {
  return await GET(`/profile-pictures`, token);
};

export const UpdateProfile = async (params: unknown, id: number | string, token: string) => {
  return await PUT(`/profiles/${id}`, params, token);
};

export const DeleteProfile = async (id: number | string, token: string) => {
  return await DELETE(`/profiles/${id}`, token);
};
